"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonParseReturnObject = exports.isPlainObject = void 0;
const isPlainObject = (value) => !!value && typeof value === "object" && !Array.isArray(value);
exports.isPlainObject = isPlainObject;
const jsonParseReturnObject = (value) => {
    if (!value) {
        return {};
    }
    if ((0, exports.isPlainObject)(value)) {
        return value;
    }
    if (typeof value === "string") {
        try {
            const parsed = JSON.parse(value);
            return (0, exports.isPlainObject)(parsed) ? parsed : {};
        }
        catch (_a) {
            return {};
        }
    }
    return {};
};
exports.jsonParseReturnObject = jsonParseReturnObject;
